import type { PageVariableSchema } from '@lighthouse/core'
import { VariableType } from '@lighthouse/core'

import { NodeAndEdgeStatusEnum } from '../../types'
import type { FlowExecutorNode } from './type'

/** 构建页面变量的链表结构 */
export function buildPageVariableDependencies(schemas: PageVariableSchema[]) {
    const result = new Map<string, FlowExecutorNode<PageVariableSchema>>()

    for (const schema of schemas) {
        if (!result.has(schema.id)) {
            result.set(schema.id, {
                id: schema.id,
                data: schema
            })
        }

        const conditions = schema.filter.expression?.conditions
        if (!conditions) {
            continue
        }

        for (const condition of conditions) {
            if (!condition.paramList) {
                continue
            }

            for (const variable of condition.paramList) {
                if (variable.type === VariableType.PAGE_DATA_QUERY && variable.pageDataQueryVariable) {
                    const { id } = variable.pageDataQueryVariable
                    const exist = schemas.some(item => item.id === id)
                    if (!exist) {
                        continue
                    }

                    const leftNode = result.get(id)
                    const leftData = schemas.find(item => item.id === id)
                    if (!leftData) {
                        continue
                    }
                    result.set(id, { id, data: leftData, left: leftNode?.left, right: [...(leftNode?.right || []), schema.id] })

                    const node = result.get(schema.id)!
                    const left = [...(node.left || []), id]
                    result.set(schema.id, { ...node, left })
                }
            }
        }
    }

    return result
}
